import { render, staticRenderFns } from "./monitoreo.vue?vue&type=template&id=64fad06b&scoped=true&"
import script from "./monitoreo.vue?vue&type=script&lang=js&"
export * from "./monitoreo.vue?vue&type=script&lang=js&"
import style0 from "./monitoreo.vue?vue&type=style&index=0&id=64fad06b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fad06b",
  null
  
)

export default component.exports